import { DarkModeToggle } from "@/components/DarkModeToggle";
import { usePageBandMounted } from "@/hooks/use-page-band";

/**
 * AppShellHeader — barre d'outils globale (toggle dark / light), montée dans
 * `AppShell` comme REPLI.
 *
 * Conformité DA : le proto n'a qu'un seul header par page — le bandeau `h-14`
 * bleu marine, logo CATHO+ blanc calé à droite. Cette barre, en `fixed
 * top-2 right-4`, se superposait exactement sur ce logo.
 *
 * Désormais le toggle vit DANS le bandeau, à gauche du logo (`PageHeader`,
 * `DashboardHeader`). Ces composants s'enregistrent via `usePageBand()` et
 * cette barre s'efface tant qu'un bandeau est monté : un seul
 * `DarkModeToggle` est rendu à la fois (deux instances auraient des états
 * locaux désynchronisés).
 *
 * Elle reste montée pour les pages sans bandeau, afin de ne perdre nulle part
 * l'accès au mode sombre.
 * - Masquée < md (sur mobile : drawer sidebar / pages individuelles).
 * - z-30 : au-dessus des cartes, sous les dialogues (`<Toaster>` est à z-100).
 */
export function AppShellHeader() {
  const bandMounted = usePageBandMounted();
  if (bandMounted) return null;

  return (
    <div
      className="hidden md:flex fixed top-2 right-4 z-30 items-center gap-2 bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm rounded-xl px-1 py-1 shadow-sm border border-gray-200 dark:border-gray-700"
      data-testid="app-shell-header"
    >
      <DarkModeToggle />
    </div>
  );
}

export default AppShellHeader;
